import { gql } from '@apollo/client';

export const QUERY = gql`
  query ShowFormSummary($organizationId: Int!, $formId: Int!) {
    showFormSummary(organizationId: $organizationId, formId: $formId) {
      id
      collected
      balance
      total_fees_due
      total_refunds
      participant_count
      participant_in_cart
      participant_in_progress
      participant_in_waitlist
    }
  }
`;
